/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
// 预热类型
export var WARMUP = 1; // 导流类型

export var DIVERSION = 2;